
import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import { useConfigModel } from "../configModel"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { IConfigSearch, IConfigParams, IConfigDetail, IConfigInsert, IConfigUpdata, IConfigDisable } from "../configTypes"
import { setTitle, filterArrId, Optios, loadDictParam } from "../../../../utils/utils"
const ConfigDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch, mdmSourceApp, mdmOrgan, dict } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, replaceNav, findNav } = useNavModel()
    const { addParam, selectedRow, setAddParam, setSelectedRow, setSelectedRowKeys, updataAddParam, updataEditParam, insertDetail, updataDetail } = useConfigModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams } = modes
    const { mode, id: ids } = pageParams
    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow[0])
        }
    }, [addParam, selectedRow[0]])
    const onFinish = (values: IConfigInsert | IConfigUpdata) => {
        if (mode == DetailType.add) {
            insertDetail(values as IConfigInsert).then(res => res && close())
        } else if (mode == DetailType.edit) {
            updataDetail(values as IConfigDetail).then(res => res && close())
        }
    }
    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-6-1")
    //         const findEdit = findNav("2-6-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])
    const close = () => {
        replaceNav(selectedNavId, "2-6")
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "配置编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "配置的值",
            labelCol: { span: 6 },
            fieldName: "value",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "备注",
            labelCol: { span: 6 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}配置</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
    </Form>
}
export default ConfigDetail